(function () {
  'use strict';
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    try {
      var p = window.location.pathname || '';
      if (p.indexOf('/cart') !== -1 || p.endsWith('/cart')) {
        window.location.reload();
      }
    } catch (e) {}
  });
})();
